import React from "react";
import styles from "./Calculator.module.css";

export type CalculatorBarChartProps = {
  data: number[];
  formatValue: (_value: number) => string;
  yearLabel?: string;
  maxBarHeight?: number;
  chartHeight?: number;
};

export const CalculatorBarChart: React.FC<CalculatorBarChartProps> = ({
  data,
  formatValue,
  yearLabel = "Yr",
  maxBarHeight = 100,
  chartHeight = 120,
}) => {
  const maxValue = Math.max(...data) || 1;

  return (
    <div className={styles.barChart} style={{ height: chartHeight }}>
      {data.map((barValue, index) => {
        const barHeight = Math.max(4, (barValue / maxValue) * maxBarHeight);
        return (
          <div key={index} className={styles.barWrapper}>
            <div className={styles.bar} style={{ height: barHeight }} />
            <div className={styles.barValue}>{formatValue(barValue)}</div>
            <div className={styles.barLabel}>{yearLabel} {index + 1}</div>
          </div>
        );
      })}
    </div>
  );
};
